/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Liability_Content_TitleInputs */

const en_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liability for Content`)
};

const de_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haftung fuer Inhalte`)
};

const fr_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilité pour le contenu`)
};

const es_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilidad por el contenido`)
};

const it_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilità per i contenuti`)
};

const nl_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aansprakelijkheid voor inhoud`)
};

const pl_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiedzialność za treść`)
};

const fi_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastuu sisällöstä`)
};

const da_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvar for indhold`)
};

const sv_impressum_liability_content_title = /** @type {(inputs: Impressum_Liability_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvar för innehåll`)
};

/**
* | output |
* | --- |
* | "Liability for Content" |
*
* @param {Impressum_Liability_Content_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_liability_content_title = /** @type {((inputs?: Impressum_Liability_Content_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Liability_Content_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_liability_content_title(inputs)
	if (locale === "fr") return fr_impressum_liability_content_title(inputs)
	if (locale === "es") return es_impressum_liability_content_title(inputs)
	if (locale === "it") return it_impressum_liability_content_title(inputs)
	if (locale === "nl") return nl_impressum_liability_content_title(inputs)
	if (locale === "pl") return pl_impressum_liability_content_title(inputs)
	if (locale === "fi") return fi_impressum_liability_content_title(inputs)
	if (locale === "da") return da_impressum_liability_content_title(inputs)
	if (locale === "sv") return sv_impressum_liability_content_title(inputs)
	return en_impressum_liability_content_title(inputs)
});